import React, { Component } from 'react'
import { Row, Col, Alert, Select, Button } from 'antd'

const Option = Select.Option

class AdminRolesForm extends Component {

    constructor(props) {
        super(props)
        this.updateForm = this.updateForm.bind(this)
        this.state = Object.assign({}, this.props.data)
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.data)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.props.storeItem(this.state)
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Perfil' : 'Criar Novo Perfil'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="rolename" className="ant-form-item-required" title="Nome do Perfil">
                                    Nome do Perfil
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="rolename"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.rolename}
                                    ref="rolename"
                                    onChange={(e) => this.updateForm('rolename', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="rolename" className="ant-form-item-required" title="Grupo de Permissões">
                                    Grupo de Permissões
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Select value={''+this.state.sysname}
                                    onChange={(v) => this.updateForm('sysname', v)}>
                                    <Option key={'superuser'} value={'superuser'}>Super User</Option>
                                    <Option key={'apaadmin'} value={'apaadmin'}>Administrador APA</Option>
                                    <Option key={'apauser'} value={'apauser'}>Utilizador APA</Option>
                                    <Option key={'entadmin'} value={'entadmin'}>Administrador Entidade</Option>
                                    <Option key={'entuser'} value={'entuser'}>Utilizador Entidade</Option>
                                    <Option key={'siarluser'} value={'siarluser'}>Utilizador SIARL</Option>
                                </Select>
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="O perfil foi guardado com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                        <i className="anticon anticon-save"></i>
                                        <span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/admin/roles')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminRolesForm;



// WEBPACK FOOTER //
// ./src/components/AdminRolesForm.js